import api from '../utils/api';

export async function listInstagramAccounts() {
  const { data } = await api.get('/instagram/accounts');
  return data;
}

export async function createInstagramAccount(payload) {
  const { data } = await api.post('/instagram/accounts', payload);
  return data;
}

export async function updateInstagramAccount(id, payload) {
  const { data } = await api.patch(`/instagram/accounts/${id}`, payload);
  return data;
}
